module.exports = __webpack_public_path__ + "media/images/icon-calendar-e1d3267adf005afa395cac92fa15b030.png";